"use client";

import GailLoader from "@/components/shared/GailLoader";
import { buildSignUpUrlWithUtm } from "@/utils/utm";
import {
  useAppLinkRouting,
  useRoutedGailAppUrl,
} from "@/providers/AppLinkRoutingProvider";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

const SignUpPage = () => {
  const router = useRouter();
  const { isReady } = useAppLinkRouting();
  const signUpUrl = useRoutedGailAppUrl("https://app.meetgail.com");

  useEffect(() => {
    if (!isReady) return;
    router.push(buildSignUpUrlWithUtm(signUpUrl));
  }, [isReady, router, signUpUrl]);

  return <GailLoader />;
};

export default SignUpPage;
